// //Update code
// import { configureStore, combineReducers } from "@reduxjs/toolkit";
// import { persistReducer, persistStore } from "redux-persist";
// // import storage from "redux-persist/lib/storage"; //localStorage
// import authReducer from "../slice/authSlice";
// import loadingReducer from "../slice/loadingSlice";
// import onBoardWizardReducer from "../slice/onBoardWizardSlice";
// import userReducer from "../slice/userSlice";
// import profileTabSectionReducer from "../slice/profileTabSectionSlice";
// import signupFormReducer from "../slice/signupFormSlice";
// import forgetPasswordReducer from "../slice/forgetPasswordSlice";
// import multiStepSlice from "../slice/multiStepSlice";
// import jobSlice from "../slice/jobSlice";
// import facilityLocationSlice from "../slice/facilityLocationSlice";
// import tableViewSlice from "../slice/tableViewSlice";
// import chatWindowSlice from "../slice/chatWindowSlice";
// import selectedRowSlice from "../slice/selectedRowSlice.js";
// import selectedJobCardSlice from "../slice/selectedJobCardSlice.js";
// import selectedCheckListSlice from "../slice/checkListSlice.js";
// import lessonSlice from "../slice/lessonSlice.js";
// import trainingTabsSlice from "../slice/trainingTabsSlice.js";
// import storageSession from 'redux-persist/lib/storage/session'; //sessionStorage


// // Detect if we are in an iframe
// const isIframe = window !== window.parent;

// // Generate a unique session key per tab --04 april
// const sessionKey = sessionStorage.getItem("reduxPersistKey") || `root-${Date.now()}`;
// sessionStorage.setItem("reduxPersistKey", sessionKey);

// // ✅ Define reducers for parent window
// const appReducer = combineReducers({
//     auth: authReducer,
//     user: userReducer,
//     profileTabSection: profileTabSectionReducer,
//     job: jobSlice,
//     loading: loadingReducer,
//     onBoardWizard: onBoardWizardReducer,
//     forgetPassword: forgetPasswordReducer,
//     signupForm: signupFormReducer,
//     multiStep: multiStepSlice,
//     facilityLocation: facilityLocationSlice,
//     tableView: tableViewSlice,
//     chatWindow: chatWindowSlice,
//     selectedRow: selectedRowSlice,
//     selectedJob: selectedJobCardSlice,
//     checkListDatail: selectedCheckListSlice,
//     lesson: lessonSlice,
//     trainingTabs: trainingTabsSlice,

// });

// // ✅ Define reducers for iframe
// const iframeReducers = combineReducers({
//     auth: authReducer,
//     user: userReducer,
//     profileTabSection: profileTabSectionReducer,
//     job: jobSlice,
//     loading: loadingReducer,
//     onBoardWizard: onBoardWizardReducer,
//     forgetPassword: forgetPasswordReducer,
//     signupForm: signupFormReducer,
//     multiStep: multiStepSlice,
//     facilityLocation: facilityLocationSlice,
//     tableView: tableViewSlice,
//     chatWindow: chatWindowSlice,
//     selectedRow: selectedRowSlice,
//     selectedJob: selectedJobCardSlice,
//     checkListDatail: selectedCheckListSlice,
//     lesson: lessonSlice,
//     trainingTabs: trainingTabsSlice,
// });

// // ✅ Wrap reducers to handle logout correctly
// const rootReducer = (state, action) => {
//     if (action.type === "LOGOUT") {
//         // storage.removeItem("persist:root");  // 🛑 Clear persisted storage
//         sessionStorage.removeItem(`persist:${sessionKey}`); // 🛑 Clear persisted storage
//         return appReducer(undefined, action); // Reset Redux state
//     }
//     return appReducer(state, action);
// };

// const selectedReducer = isIframe
//     ? (state, action) => {
//         if (action.type === "LOGOUT") {
//             // storage.removeItem("persist:iframe-root"); 
//             sessionStorage.removeItem("persist:iframe-root"); // 🛑 Clear iframe storage
//             return iframeReducers(undefined, action);
//         }
//         return iframeReducers(state, action);
//     }
//     : rootReducer;

// // ✅ Configure persistence
// // const PersistedConfigure = {
// //     key: isIframe ? "iframe-root" : "root",
// //     storage,
// // };
// const PersistedConfigure = { //--04April
//     key: sessionKey, // Use dynamic session key to isolate state per tab
//     storage: storageSession, // Session storage to avoid shared state
// };

// // ✅ Persist the selected reducer
// const PersistedReducer = persistReducer(PersistedConfigure, selectedReducer);

// // ✅ Configure the store
// const store = configureStore({
//     reducer: PersistedReducer,
//     middleware: (getDefaultMiddleware) =>
//         getDefaultMiddleware({
//             serializableCheck: {
//                 ignoredActions: [
//                     "persist/PERSIST",
//                     "persist/REHYDRATE",
//                     "persist/FLUSH",
//                     "persist/PAUSE",
//                     "persist/REMOVE",
//                 ],
//                 ignoredPaths: ["persist"],
//             },
//         }),
//     devTools: true,
// });

// // ✅ Persistor
// const persistor = persistStore(store);

// // ✅ Listen for storage events to handle multiple tabs --04April
// window.addEventListener("storage", (event) => {
//     if (event.key === "reduxPersistKey") {
//         window.location.reload(); // Refresh when key changes
//     }
// });

// export { store, persistor };

import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import storageSession from "redux-persist/lib/storage/session"; // sessionStorage

// Import all slices
import authReducer from "../slice/authSlice";
import loadingReducer from "../slice/loadingSlice";
import onBoardWizardReducer from "../slice/onBoardWizardSlice";
import userReducer from "../slice/userSlice";
import profileTabSectionReducer from "../slice/profileTabSectionSlice";
import signupFormReducer from "../slice/signupFormSlice";
import forgetPasswordReducer from "../slice/forgetPasswordSlice";
import multiStepSlice from "../slice/multiStepSlice";
import jobSlice from "../slice/jobSlice";
import facilityLocationSlice from "../slice/facilityLocationSlice";
import tableViewSlice from "../slice/tableViewSlice";
import chatWindowSlice from "../slice/chatWindowSlice";
import selectedRowSlice from "../slice/selectedRowSlice";
import selectedJobCardSlice from "../slice/selectedJobCardSlice";
import selectedCheckListSlice from "../slice/checkListSlice";
import lessonSlice from "../slice/lessonSlice";
import trainingTabsSlice from "../slice/trainingTabsSlice";

// Detect if we are in an iframe
const isIframe = window !== window.parent;

// 🔐 Dynamic session key for tab isolation
const sessionKey = sessionStorage.getItem("reduxPersistKey") || `root-${Date.now()}`;
sessionStorage.setItem("reduxPersistKey", sessionKey);

// 🔁 Combine all reducers once
const combinedReducers = combineReducers({
    auth: authReducer,
    user: userReducer,
    profileTabSection: profileTabSectionReducer,
    job: jobSlice,
    loading: loadingReducer,
    onBoardWizard: onBoardWizardReducer,
    forgetPassword: forgetPasswordReducer,
    signupForm: signupFormReducer,
    multiStep: multiStepSlice,
    facilityLocation: facilityLocationSlice,
    tableView: tableViewSlice,
    chatWindow: chatWindowSlice,
    selectedRow: selectedRowSlice,
    selectedJob: selectedJobCardSlice,
    checkListDatail: selectedCheckListSlice,
    lesson: lessonSlice,
    trainingTabs: trainingTabsSlice,
});

// 🔁 Root reducer with logout handling
const rootReducer = (state, action) => {
    if (action.type === "LOGOUT") {
        const persistKey = isIframe ? "persist:iframe-root" : `persist:${sessionKey}`;
        sessionStorage.removeItem(persistKey); // 🧹 Clear sessionStorage persist key
        return combinedReducers(undefined, action); // 🧼 Reset Redux state
    }
    return combinedReducers(state, action);
};

// ⚙️ Persist config
const persistConfig = {
    key: isIframe ? "iframe-root" : sessionKey,
    storage: storageSession,
};

// 🧠 Create persisted reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// 🏗️ Configure store
const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [
                    "persist/PERSIST",
                    "persist/REHYDRATE",
                    "persist/FLUSH",
                    "persist/PAUSE",
                    "persist/REMOVE",
                ],
                ignoredPaths: ["persist"],
            },
        }),
    devTools: process.env.NODE_ENV !== "production",
});

// 🔁 Create persistor
const persistor = persistStore(store);

// 🔄 Sync tabs (reload if key changes)
window.addEventListener("storage", (event) => {
    if (event.key === "reduxPersistKey") {
        window.location.reload();
    }
});

export { store, persistor };
